import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import { organizationTabTypes } from "@/util";
import { TabList, SidebarGrid } from "@/components/common";
import {
  OrganizationButtons,
  OrganizationDisplay,
} from "@/components/organization/save";
import { OrgMemberTable } from "@/components/members";
import { TeamTab, TransactionTab } from "@/components/organization/tabs";


/**
 * Tabs for changing organization settings.
 */
const __default__ = {
  name: "OrganizationTabs",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const tabs = organizationTabTypes();

const tab = ref(tabs[0].id);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SidebarGrid), null, {
    sidebar: _withCtx(() => [
      _createVNode(_unref(OrganizationButtons)),
      _createVNode(_unref(OrganizationDisplay))
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(TabList), {
        modelValue: tab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
        tabs: _unref(tabs)
      }, {
        members: _withCtx(() => [
          _createVNode(_unref(OrgMemberTable))
        ]),
        teams: _withCtx(() => [
          _createVNode(_unref(TeamTab))
        ]),
        billing: _withCtx(() => [
          _createVNode(_unref(TransactionTab))
        ]),
        _: 1
      }, 8, ["modelValue", "tabs"])
    ]),
    _: 1
  }))
}
}

})